import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import OnboardingHubPageComponentQuery from './__generated__/OnboardingHubPageComponentQuery.graphql';

export const onboardingHubEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-onboarding-hub" */ './OnboardingHubPageComponent.tsx'),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { appEditions, cloudId, isAdmin } = tenantContext;

		const queries = {
			onboardingHubQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: OnboardingHubPageComponentQuery,
				variables: {
					cloudId,
					upsellEnabled:
						appEditions?.software !== 'PREMIUM_EDITION' &&
						fg('restrict-custom-onboarding-to-premium-tier'),
					hamsProductKey: 'jira-software.ondemand',
					rollingIntervals: [
						'DAYS_1' as const,
						'DAYS_7' as const,
						'DAYS_30' as const,
						'DAYS_90' as const,
						'DAYS_180' as const,
					],
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins), or
					// 3. The delegated admin gate is disabled (because only admins would be able to view the feature)
					skipDelegatedAdminCheck:
						isAdmin ||
						(appEditions?.software !== 'PREMIUM_EDITION' &&
							fg('restrict-custom-onboarding-to-premium-tier')) ||
						!fg('jira-delegated-custom-onboarding'),
				},
			},
		};

		return { queries };
	},
});
